import React from 'react';
import styles from './loader.module.css';

type TSpinnerProps = {
  /** Диаметр в px (по умолчанию 44). */
  size?: number;
  /** Белое кольцо — для оранжевых кнопок. */
  light?: boolean;
  className?: string;
};

/** Кольцо загрузки в градиенте бренда — одно на сайт и панель. */
const Spinner: React.FC<TSpinnerProps> = ({ size = 44, light = false, className }) => {
  const width = size <= 20 ? 2.5 : size <= 32 ? 3 : 4;
  return (
    <span
      className={[styles.ring, light ? styles.ringLight : '', className ?? ''].join(' ').trim()}
      style={{ '--ring-size': `${size}px`, '--ring-w': `${width}px` } as React.CSSProperties}
      role="status"
      aria-label="Загрузка"
    />
  );
};

export default Spinner;
